import { LEGAL_DOCUMENTS } from './documents.config';
import { LegalDocumentPage } from './legal-document-page';
import { resolveLocale } from './locale';

/**
 * Unauthenticated /eula route (ESCLOUD-286): the onboarding plan screen's
 * acceptance checkbox links here, so the agreement is readable before it is
 * accepted — and before any session exists.
 */
export function EulaPage() {
    const config = LEGAL_DOCUMENTS.eula;
    const locale = resolveLocale(config.locales);
    return (
        <LegalDocumentPage
            title={config.titles[locale]}
            version={config.version}
            effectiveDate={config.effectiveDate}
            contentType="eula"
            locale={locale}
        />
    );
}
